import { useEffect } from "react";

const PricecFieldTransacModal = ({
  handleChange,
  transactionData,
  setTransactionData,
  activesList,
  alertPrice,
}) => {
  useEffect(() => {
    if (!transactionData.custom_price) {
      const active = activesList[transactionData.active_type]?.find(
        (active) => active.id == transactionData.active_category
      );
      const price = active?.price * transactionData.amount || active?.price;
      setTransactionData({ ...transactionData, price: price });
    }
  }, [
    transactionData.active_type,
    transactionData.active_category,
    transactionData.amount,
  ]);
  return (
    <div className="input-field flex-fill">
      <label htmlFor="ageFormControlInput" className="form-label">
        Precio
        <strong className="text-danger">*</strong>
        <span className={alertPrice ? "fst-italic m-2 text-danger" : "d-none"}>
          No valido.
        </span>
      </label>
      <div className="input-group mb-3">
        <input
          type="number"
          className={
            alertPrice ? "border border-danger form-control" : "form-control"
          }
          disabled={!transactionData.custom_price}
          value={transactionData.price}
          onChange={(e) => handleChange(e, "price")}
        />
        <div className="input-group-text gap-2" id="basic-addon2">
          <input
            className="form-check-input mt-0"
            type="checkbox"
            checked={transactionData.custom_price}
            onChange={(e) => {
              setTransactionData((prevTransactionData) => {
                return {
                  ...prevTransactionData,
                  custom_price: !prevTransactionData.custom_price,
                };
              });
            }}
          />
          <span>Personalizado</span>
        </div>
      </div>
    </div>
  );
};

export default PricecFieldTransacModal;
